module.exports = __webpack_public_path__ + "assets/img/jobs.6cc92cd7.svg";